module.exports = __webpack_public_path__ + "img/button_chatroom-Text.039c524e.svg";